import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Cancel, SearchIcon } from "../../../styled/AllImages";
import {
  Box,
  ButtonStyled,
  HeadingStyled,
  SpanStyled,
} from "../../../styled/Elements";

import { useTranslation } from "react-i18next";
import { CustomCheckbox } from "../../../styled/FormElements";
import styled from "styled-components";
import FloatingInput from "../../inputFields/FloatingInput";

const MultipleDepartmentsModal = ({
  show,
  onHide,
  title,
  mainParents,
  selectedMainParents,
  setSelectedMainParents,
}) => {
  const { t } = useTranslation();

  const [filteredList, setFilteredList] = useState([]);
  const [checkedUsers, setCheckedUsers] = useState([]);

  const handleSearch = (e) => {
    const { value } = e.target;
    const searchQuery = value.toLowerCase();

    const updatedList = mainParents.filter((item) => {
      if (item.name) {
        return item.name.toLowerCase().includes(searchQuery);
      }
      return (
        item.name?.toLowerCase().includes(searchQuery) ||
        item.subLabel?.toLowerCase().includes(searchQuery)
      );
    });

    setFilteredList(updatedList);
  };

  useEffect(() => {
    setFilteredList(mainParents);
  }, [mainParents, show]);

  useEffect(() => {
    if (show) {
      setCheckedUsers(selectedMainParents);
    }
  }, [show, selectedMainParents]);

  const handleCheckboxChange = (mainParent) => {
    if (checkedUsers.some((selected) => selected.id === mainParent.id)) {
      setCheckedUsers(
        checkedUsers.filter((selected) => selected.id !== mainParent.id)
      );
    } else {
      setCheckedUsers([...checkedUsers, mainParent]);
    }
  };

  const handleAddClick = () => {
    setSelectedMainParents(checkedUsers);
    onHide();
  };

  return (
    <Modal size="md" show={show} onHide={onHide} centered>
      <Box className="d-flex justify-content-between align-items-center p-3">
        <HeadingStyled size="24px" color="var(--text)">
          {title}
        </HeadingStyled>
        <span className="close-button cursor-pointer" onClick={onHide}>
          <Cancel />
        </span>
      </Box>
      <Box className="d-flex p-3 pt-0 border-bottom">
        <FloatingInput
          name="search"
          type="input"
          fieldType="text"
          label={t("search")}
          placeholder={t("search")}
          icon={SearchIcon}
          onChange={handleSearch}
        />
      </Box>

      <ScrollableContainer>
        {filteredList &&
          filteredList.map((mainParent) => (
            <MultipleDepartmentsRow
              href="#!"
              className={`userDataRow ${
                selectedMainParents.some(
                  (selected) => selected.id === mainParent.id
                ) && "selected"
              }`}
              key={mainParent.id}
            >
              <Box className="userDataContainer">
                <Box className="userDataInfo">
                  <Box className="userDataNameRole">
                    <SpanStyled
                      color="var(--text)"
                      size="16px"
                      weight="bold"
                      className=""
                    >
                      {mainParent.name}
                    </SpanStyled>
                    {mainParent?.subLabel && (
                      <SpanStyled
                        color="var(--text2)"
                        size="14px"
                        className=""
                      >
                        {mainParent.subLabel}
                      </SpanStyled>
                    )}
                  </Box>
                  <Box className="userDataCheckBox">
                    <CustomCheckbox
                      name="users"
                      checked={checkedUsers.some(
                        (selected) => selected.id === mainParent.id
                      )}
                      onChange={() => handleCheckboxChange(mainParent)} // Only change on checkbox
                      // as="div"
                    />
                  </Box>
                </Box>
              </Box>
            </MultipleDepartmentsRow>
          ))}
      </ScrollableContainer>
      <div className="modal-footer">
        <ButtonStyled
          label={t("Cancel")}
          onClick={onHide}
          bg="var(--bgSecondary)"
          color="var(--text2)"
        />
        <ButtonStyled
          bg="var(--themeColor)"
          label={t("add")}
          onClick={handleAddClick} // Add only checked users
        />
      </div>
    </Modal>
  );
};

export default MultipleDepartmentsModal;
const MultipleDepartmentsRow = styled.div`
  padding: 1rem;
  border-bottom: 1px solid var(--borderLight);
  width: 100%;
  cursor: pointer;
  .userDataContainer {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
  }
  .userDataInfo {
    display: flex;
    width: 100%;
    align-items: center;
    gap: 16px;
    padding-right: 10px;
    .userDataImg {
      display: block;
      min-width: 48px;
      max-width: 48px;
      height: 48px;
      border-radius: 50%;
      overflow: hidden;
      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }
    .userDataNameRole {
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      span {
        width: 100%;
      }
    }
  }
  .userDataCheckBox {
    .customCheck {
      padding-left: 26px;
    }
  }
`;

const ScrollableContainer = styled.div`
  max-height: 300px;
  overflow-y: auto;
  margin-bottom: 10px;
  border-radius: 12px;
  padding: 8px;

  /* Scrollbar Styles */
  &::-webkit-scrollbar {
    width: 7px;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    background: var(--bgSecondary);
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #e4e8ef;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #b8c0cc;
  }
`;
